import { useState } from 'react';
import { CatalogCreationCriterionOptionLabelsById } from '../catalogCreationCriteria.types';

export const useCatalogCreationCriteriaOptionLabels = () => {
  const [optionLabelsById, setOptionLabelsById] =
    useState<CatalogCreationCriterionOptionLabelsById>({});

  const registerOptionLabels = (optionLabels: CatalogCreationCriterionOptionLabelsById) => {
    setOptionLabelsById((currentOptionLabels) => ({ ...currentOptionLabels, ...optionLabels }));
  };

  return { optionLabelsById, registerOptionLabels };
};
